
define('text!modules/reporting/campaigns/geoPerformance/templates/panel.html',[],function () { return '<div class="w-panel-body w-report-panel check-radio-forms"></div>\n<div class="loader-container">\n  <div class="loader-block"></div>\n</div>\n';});

